import {
    PlatformNavbar,
    PlatformNavbarMode
} from "@flexinet/ui-components";
import {getMenuItems} from "../data/menus";
import {useTags} from "../../../features/tags/hooks/useTags.ts";
import {useEffect} from "react";
import {Tag} from "../../../features/tags/types.ts";
import {AiOutlineTag} from "react-icons/ai";
import {IconContext} from "react-icons";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {filterMenuItems} from "../filterMenuItems.ts";

export const PortalNavbar = (
    {
        mode,
        changeMode
    }: {
        mode: PlatformNavbarMode,
        changeMode: (mode: PlatformNavbarMode) => void
    }
) => {

    const {allowedActions} = useVerifiedPermissions()

    const items = getMenuItems()


    const useMenuTags = true

    const {
        items: tags,
        fetchRecords
    } = useTags()

    useEffect(() => {
        fetchRecords()
    }, []);


    if (useMenuTags) {

        const tagsGroupLink = items.find(item => item.id === 'tags-group')
        if (tagsGroupLink) {
            tagsGroupLink.links = [];
            tags.forEach((tag: Tag) => {
                tagsGroupLink?.links?.push({
                                               id: tag.id,
                                               label: tag.name as string,
                                               link: `/messages/tag/${tag.id}`,
                                               leftSection: <IconContext.Provider
                                                   value={{size: '1.6em'}}><AiOutlineTag/></IconContext.Provider>,
                                               rbac: rbacActions.ListTags
                                           })
            })
        }

    }

    // Filters nested links[] as well as top-level items (FNP-1119). The tag
    // children built just above carry rbacActions.ListTags, so they are filtered
    // on the same pass rather than inheriting the group's visibility.
    const menuItems = filterMenuItems(items, allowedActions);


    return <PlatformNavbar
        appTitle={'Flexi Email'}
        menuItems={menuItems}
        mode={mode}
        changeMode={changeMode}
    />

};